/**
 * Miscellaneous utilities to help with processing tessellated material surface geometry.
 * @module
 */
import degreeToRadian from "common/utils/degreeToRadian";
import type { AABB2 } from "geom/aabb2Types";
import { vec2Rotate } from "geom/vec2";

export type MaterialLayoutInfo = AABB2[];
export interface UVLayoutInfo {
  [materialId: string]: MaterialLayoutInfo;
}

export type AdjustGeoType = "DONT_ADJUST" | "ADJUST_ALL" | "ADJUST_EXCLUDING_UPWARDS";

export function uvLayoutInfoNew(): UVLayoutInfo {
  return {};
}

export function getLayoutInfoForMaterial(materialID: string, layoutInfo: UVLayoutInfo): MaterialLayoutInfo {
  if (layoutInfo[materialID]) {
    return layoutInfo[materialID];
  } else {
    layoutInfo[materialID] = [];
    return layoutInfo[materialID];
  }
}

export function scaleVerts(vertices: Float32Array | number[], scaleX: number, scaleY: number, scaleZ: number) {
  for (let i = 0, ic = vertices.length / 3; i < ic; ++i) {
    vertices[i * 3] *= scaleX;
    vertices[i * 3 + 1] *= scaleY;
    vertices[i * 3 + 2] *= scaleZ;
  }
}

export function translateVerts(vertices: Float32Array | number[], addX: number, addY: number, addZ: number) {
  for (let i = 0, ic = vertices.length / 3; i < ic; ++i) {
    vertices[i * 3] += addX;
    vertices[i * 3 + 1] += addY;
    vertices[i * 3 + 2] += addZ;
  }
}

export function rotateVertsZ(vertices: Float32Array | number[], degrees: number) {
  if (degrees !== 0.0) {
    const rotRad = degreeToRadian(degrees);
    for (let i = 0, ic = vertices.length / 3; i < ic; ++i) {
      const [nx, ny] = vec2Rotate(vertices[i * 3], vertices[i * 3 + 1], rotRad);
      vertices[i * 3] = nx;
      vertices[i * 3 + 1] = ny;
    }
  }
}

export function rotateVertsY(vertices: Float32Array | number[], degrees: number) {
  if (degrees !== 0.0) {
    const rotRad = degreeToRadian(degrees);
    for (let i = 0, ic = vertices.length / 3; i < ic; ++i) {
      const [nx, nz] = vec2Rotate(vertices[i * 3], vertices[i * 3 + 2], rotRad);
      vertices[i * 3] = nx;
      vertices[i * 3 + 2] = nz;
    }
  }
}

export function rotateVertsX(vertices: Float32Array | number[], degrees: number) {
  if (degrees !== 0.0) {
    const rotRad = degreeToRadian(degrees);
    for (let i = 0, ic = vertices.length / 3; i < ic; ++i) {
      const [ny, nz] = vec2Rotate(vertices[i * 3 + 1], vertices[i * 3 + 2], rotRad);
      vertices[i * 3 + 1] = ny;
      vertices[i * 3 + 2] = nz;
    }
  }
}
